export const DocumentsTags = {
  Documents: 'Documents',
  Summary: 'DocumentsSummary',
} as const;
